import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ButtonModule } from 'primeng/button';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { CommonModule } from '@angular/common';
import { CommunicationNoteComponent } from "../communication-note/communication-note.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
declare var RingoverSDK: any;


@Component({
  selector: 'app-lead-call',
  imports: [ButtonModule, NgxIntlTelInputModule, FormsModule, CommonModule, ReactiveFormsModule, CommunicationNoteComponent,
    SharedModule
  ],
  templateUrl: './lead-call.component.html',
  styleUrl: './lead-call.component.scss'
})
export class LeadCallComponent {

  @Output() closeDialog = new EventEmitter<any>();

  constructor(private fb: FormBuilder) { }

  @Input() communicationData: any = {};

  btnLoading: boolean = false;
  isDropdownOpen: boolean = false;

  phoneForm!: FormGroup;
  phoneNumberUtil = PhoneNumberUtil.getInstance();
  timeWhenCallStarted: any;
  timeWhenCallEnded: any;
  hangUpCallData: any;

  simpleSDK: any;
  notes: string = '';
  isDialerReady: boolean = false;
  btnLoading3: boolean = false;
  isOpenNotesModal: boolean = false;


  ngOnInit(): void {

    this.simpleSDK = new RingoverSDK();
    this.simpleSDK.on('changePage', this.logEvent);
    this.simpleSDK.on('ringingCall', this.logEvent);
    this.simpleSDK.on('answeredCall', this.logEvent);
    this.simpleSDK.on('hangupCall', this.logEvent);
    this.simpleSDK.on('login', this.logEvent);
    this.simpleSDK.on('logout', this.logEvent);
    this.simpleSDK.on('dialerReady', this.logEvent);
    this.simpleSDK.on('smsSent', this.logEvent);
    this.simpleSDK.on('smsReceived', this.logEvent);
    this.simpleSDK.on('callLogOpened', this.logEvent);

    this.phoneForm = this.fb.group({
      phone: ['', [Validators.required]]
    });


  }

  ngOnChanges() {
    if (this.communicationData?.phone) {
      this.setPhoneValue(this.communicationData.phone);
    }
  }

  // Helper function to set phone value dynamically
  private setPhoneValue(phone: string): void {
    try {
      const parsedNumber = this.phoneNumberUtil.parseAndKeepRawInput(phone);
      const internationalNumber = this.phoneNumberUtil.format(parsedNumber, PhoneNumberFormat.INTERNATIONAL);
      console.log('Parsed phone number:', parsedNumber);
      console.log("internationalNumber", internationalNumber);
      this.phoneForm.get('phone')?.setValue(internationalNumber);
    } catch (error) {
      console.warn('Invalid phone number format:', error);
      this.phoneForm.get('phone')?.setValue(phone); // Set raw value if parsing fails
    }
  }

  // Custom validator to ensure phone number matches country code
  isPhoneNumberValid(phoneNumber: any): boolean {
    try {
      const parsedNumber = this.phoneNumberUtil.parseAndKeepRawInput(
        phoneNumber.number,
        phoneNumber.countryCode
      );
      return this.phoneNumberUtil.isValidNumber(parsedNumber);
    } catch (error) {
      console.error('Error validating phone number:', error);
      return false;
    }
  }

  // Close the modal
  closeModal() {
    this.destroy();
    this.closeDialog.emit();
    // this.close.emit();
  }

  handleCloseAllDialogs() {
    this.destroy();
    this.isOpenNotesModal = false;
    this.closeDialog.emit();
  }

  // Handle Proceed button click
  onProceed(): void {
    if (this.phoneForm.valid) {
      const phoneNumber = this.phoneForm.get('phone')?.value;

      if (this.isPhoneNumberValid(phoneNumber)) {
        console.log('Phone number is valid:', phoneNumber);
        this.generate();
        this.dial(phoneNumber);

      } else {
        console.error('Invalid phone number');
      }
    }
  }

  generate() { this.simpleSDK.generate(); }
  dial(number: any) { this.simpleSDK.dial(number?.e164Number); }
  logEvent = (e: any) => {
    console.log("Action", e?.action);
    console.log("Data", e?.data);

    if (e?.action === "dialerReady") {
      this.isDialerReady = true;
    }

    if (e?.action === "ringingCall") {
      this.timeWhenCallStarted = new Date();
    }

    if (e?.action === "hangupCall") {
      this.timeWhenCallEnded = new Date();
      console.log("Call Duration", this.timeWhenCallEnded - this.timeWhenCallStarted);

      this.hangUpCallData = e?.data;

      this.destroy();

      this.isOpenNotesModal = true;
    }

    // const p = document.createElement('pre');
    // p.innerText = `${e.action} => ${JSON.stringify(e.data)}`;
    // document.getElementById('get-events')?.appendChild(p);
  };

  destroy() { this.simpleSDK.destroy(); }


  handleCloseCallDialog() {
    this.destroy();
    this.closeDialog.emit();
  }

  getFullName() {
    let user = this.communicationData;
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

}
